import { USER_PERMISSION_CODES } from "./chucNangs/admin/userChucNangs";
import { AUDIT_PERMISSION_CODES } from "./chucNangs/audit/auditChucNangs";
import { REQUEST_PERMISSION_CODES } from "./chucNangs/office/requestChucNangs";
import { WORKFLOW_PERMISSION_CODES } from "./chucNangs/office/workflowChucNangs";
import { LEAVE_REQUEST_PERMISSION_CODES } from "./chucNangs/office/leaveRequestChucNangs";
import { RECRUITMENT_REQUEST_PERMISSION_CODES } from "./chucNangs/recruitment/recruitmentRequestChucNangs";
import { CANDIDATE_PERMISSION_CODES } from "./chucNangs/recruitment/candidateChucNangs";
import { INTERVIEW_SCHEDULE_PERMISSION_CODES } from "./chucNangs/recruitment/interviewScheduleChucNangs";
import { JOB_OFFER_PERMISSION_CODES } from "./chucNangs/recruitment/jobOfferChucNangs";
import { JOB_POSTING_PERMISSION_CODES } from "./chucNangs/recruitment/jobPostingChucNangs";
import { HR_PROFILE_PERMISSION_CODES } from "./chucNangs/hr/profileChucNangs";
import { HR_DEPARTMENT_PERMISSION_CODES } from "./chucNangs/hr/departmentChucNangs";
import { HR_TRAINING_COURSE_PERMISSION_CODES } from "./chucNangs/hr/trainingCourseChucNangs";
import { HR_JOB_TITLE_PERMISSION_CODES } from "./chucNangs/hr/jobTitleChucNangs";
import { HR_INSURANCE_PAYMENT_PERMISSION_CODES } from "./chucNangs/hr/insurancePaymentChucNangs";
import { HR_INSURANCE_BENEFIT_PERMISSION_CODES } from "./chucNangs/hr/insuranceBenefitChucNangs";
import { HR_WELFARE_FUND_PERMISSION_CODES } from "./chucNangs/hr/welfareFundChucNangs";
import { ATTENDANCE_WORK_SHIFT_PERMISSION_CODES } from "./chucNangs/attendance/workShiftChucNangs";
import { ATTENDANCE_WORK_SCHEDULE_PERMISSION_CODES } from "./chucNangs/attendance/workScheduleChucNangs";
import { ATTENDANCE_LOCATION_PERMISSION_CODES } from "./chucNangs/attendance/locationChucNangs";
import { ATTENDANCE_NETWORK_PERMISSION_CODES } from "./chucNangs/attendance/networkChucNangs";
import { ATTENDANCE_SUMMARY_PERMISSION_CODES } from "./chucNangs/attendance/attendanceSummaryChucNangs";
import { PAYROLL_COMPONENT_PERMISSION_CODES } from "./chucNangs/payroll/payrollComponentChucNangs";
import { PAYROLL_PERIOD_PERMISSION_CODES } from "./chucNangs/payroll/payrollPeriodChucNangs";
import { PAYSLIP_PERMISSION_CODES } from "./chucNangs/payroll/payslipChucNangs";
import { USER_SALARY_CONFIG_PERMISSION_CODES } from "./chucNangs/payroll/userSalaryConfigChucNangs";
import { OLD_PERMISSION_CODES, CHUC_NANG_FILTERS as OLD_CHUC_NANG_FILTERS } from "./permissionOldConstants";


export const ALL_CHUCNANG_PERMISSION_CODES = {
    ...OLD_PERMISSION_CODES,
    ...OLD_CHUC_NANG_FILTERS,

    ...USER_PERMISSION_CODES,
    ...AUDIT_PERMISSION_CODES,
    ...REQUEST_PERMISSION_CODES,
    ...WORKFLOW_PERMISSION_CODES,
    ...LEAVE_REQUEST_PERMISSION_CODES,
    ...RECRUITMENT_REQUEST_PERMISSION_CODES,
    ...CANDIDATE_PERMISSION_CODES,
    ...INTERVIEW_SCHEDULE_PERMISSION_CODES,
    ...JOB_OFFER_PERMISSION_CODES,
    ...JOB_POSTING_PERMISSION_CODES,
    ...HR_PROFILE_PERMISSION_CODES,
    ...HR_DEPARTMENT_PERMISSION_CODES,
    ...HR_TRAINING_COURSE_PERMISSION_CODES,
    ...HR_JOB_TITLE_PERMISSION_CODES,
    ...HR_INSURANCE_PAYMENT_PERMISSION_CODES,
    ...HR_INSURANCE_BENEFIT_PERMISSION_CODES,
    ...HR_WELFARE_FUND_PERMISSION_CODES,
    ...ATTENDANCE_WORK_SHIFT_PERMISSION_CODES,
    ...ATTENDANCE_WORK_SCHEDULE_PERMISSION_CODES,
    ...ATTENDANCE_LOCATION_PERMISSION_CODES,
    ...ATTENDANCE_NETWORK_PERMISSION_CODES,
    ...ATTENDANCE_SUMMARY_PERMISSION_CODES,
    ...PAYROLL_COMPONENT_PERMISSION_CODES,
    ...PAYROLL_PERIOD_PERMISSION_CODES,
    ...PAYSLIP_PERMISSION_CODES,
    ...USER_SALARY_CONFIG_PERMISSION_CODES,
    
} as const; 

export const CHUC_NANG_FILTERS = {
    ...OLD_CHUC_NANG_FILTERS,
} as const;

